import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useUpdateUserAdmin } from "@/hooks/use-mutations";
import { Input } from "@/components/ui/input";
import { formatAmount } from "@/lib/utils";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { useSheetStore } from "@/zustand/adminSheetStore";

const Wallet = ({ user }: { user: any }) => {
  const queryClient = useQueryClient();
  const { closeSheet } = useSheetStore();
  const form = useForm({
    defaultValues: {
      depositFee: user?.depositFee || 0,
      withdrawalFee: user?.withdrawalFee || 0,
    },
  });
  const { mutate: updateUser, isPending: isUpdatingUser } = useUpdateUserAdmin({
    id: user.id,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["users"],
      });
      closeSheet();
    },
  });

  const onSubmit = (data: any) => {
    updateUser({
      depositFee: Number(data.depositFee),
      withdrawalFee: Number(data.withdrawalFee),
    });
  };
  return (
    <div className="mt-4 px-4">
      <WalletCard user={user} />

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="mt-6 grid grid-cols-2 items-start gap-2 text-sm">
            <FormField
              control={form.control}
              name="depositFee"
              render={({ field }) => (
                <FormItem>
                  <FormLabel className="text-sm font-normal">
                    Deposit Fee
                  </FormLabel>
                  <FormControl>
                    <div className="relative">
                      <Input type="number" {...field} />
                      <span className="absolute top-1/2 right-2 -translate-y-1/2">
                        %
                      </span>
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="withdrawalFee"
              render={({ field }) => (
                <FormItem>
                  <FormLabel className="text-sm font-normal">
                    Withdrawal Fee
                  </FormLabel>
                  <FormControl>
                    <div className="relative">
                      <Input type="number" {...field} />
                      <span className="absolute top-1/2 right-2 -translate-y-1/2">
                        %
                      </span>
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>

          <div className="flex justify-end">
            <Button
              isLoading={isUpdatingUser}
              className="bg-primary-500 hover:bg-primary-500/90 mt-4 w-32 rounded-md"
            >
              Update
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
};

const WalletCard = ({ user }: { user: any }) => {
  return (
    <div
      className="flex items-center justify-between rounded-md border border-[#DAE1EA] p-4"
      style={{
        boxShadow: "0px 2px 4px 0px #0000000D",
      }}
    >
      <div className="flex flex-col">
        <span className="text-xs text-[#A5ACB6]">Available Balance</span>
        <span className="mt-1 text-lg leading-4 font-bold text-black">
          ${formatAmount(user?.balance)}
        </span>
      </div>
    </div>
  );
};

export default Wallet;
